import { gql } from '@apollo/client';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useQueryWithMsg } from '../../utils/hooks';
import Endash from '../basics/Endash';

const BillingStatsQuery = gql`
  query {
    unpaidFarms {
      id
      name
      updatedAt
      members {
        id
        email
        role
      }
    }
    unpaidTeams {
      id
      name
      farms {
        id
      }
      members {
        id
        email
        role
      }
    }
  }
`;

const BillingReportContentContainer = styled.div`
  overflow-y: scroll;
  max-height: 90%;
`;

const EditorEntry = ({ email, role }) => {
  return (
    <div className="pl-1">
      Email: {email}, Role: {role}
    </div>
  );
};

const TeamEntry = ({ id, name, farms, members }) => {
  return (
    <div className="p-1">
      <div className="d-flex">
        <Link to={`/superadmin/teams/${id}/members`}>{name}: </Link>
        <Endash />
        <div>Project Count: {(farms || []).length}</div>
      </div>
      {members
        .filter(({ role }) => role !== 'viewer')
        .map((editor) => (
          <EditorEntry key={`${id}-${editor.id}`} {...editor} parentId={id} />
        ))}
    </div>
  );
};

const FarmEntry = ({ id, name, updatedAt, members }) => {
  return (
    <div className="p-1">
      <div className="d-flex">
        <Link to={`/superadmin/farms/${id}/edit`}>{name}: </Link>
        <Endash />
        <div> Updated At: {updatedAt}</div>
      </div>
      {members
        .filter(({ role }) => role !== 'viewer')
        .map((editor) => (
          <EditorEntry key={`${id}-${editor.id}`} {...editor} parentId={id} />
        ))}
    </div>
  );
};

const SuperadminBillingReport = () => {
  const { msg, data } = useQueryWithMsg(BillingStatsQuery, {
    fetchPolicy: 'cache-and-network',
  });

  if (msg) return <div>{msg}</div>;

  return (
    <BillingReportContentContainer>
      <div className="font-weight-bold py-2">
        Farm Editor Shares without Valid Subscription
      </div>
      {data?.unpaidFarms?.map((farm) => (
        <FarmEntry key={`farm-${farm.id}`} {...farm} />
      ))}
      <div className="font-weight-bold py-2">
        Team Editors without Valid Subscription
      </div>
      {data?.unpaidTeams?.map((team) => (
        <TeamEntry key={`team-${team.id}`} {...team} />
      ))}
    </BillingReportContentContainer>
  );
};

export default SuperadminBillingReport;
